import { render, staticRenderFns } from "./PlaceDelete.vue?vue&type=template&id=44cf1bc2&scoped=true&"
import script from "./PlaceDelete.vue?vue&type=script&lang=js&"
export * from "./PlaceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf1bc2",
  null
  
)

export default component.exports